export const CROSSCUTTING_DONE_HISTORY_LIST_REQUEST = "CROSSCUTTING_DONE_HISTORY_LIST_REQUEST";
export const CROSSCUTTING_DONE_HISTORY_LIST_SUCCESS = "CROSSCUTTING_DONE_HISTORY_LIST_SUCCESS";
export const CROSSCUTTING_DONE_HISTORY_LIST_FAILED = "CROSSCUTTING_DONE_HISTORY_LIST_FAILED";
